import { Col, Media, Row } from "reactstrap";
import { ContentBlock } from "../Shared/Content/ContentBlock";
import { ContentHeading } from "../Shared/Content/ContentHeading";
import { ContentBody } from "../Shared/Content/ContentBody";

interface IProps {
    fieldAdditionalServicesSectionTitle: string,
    fieldAdditionalServicesData: any
}

export const Benefits = ({ fieldAdditionalServicesSectionTitle, fieldAdditionalServicesData }: IProps) => {
    // additional services image max forced width and height inline CSS
    const additionalServicesImgStyle = {
        maxHeight: 165,
        maxWidth: 165
    }

    return (
            <ContentBlock className="benefits">
                <ContentHeading title={fieldAdditionalServicesSectionTitle} />
                <ContentBody>
                    <Row className="additionalServices">
                        {
                            fieldAdditionalServicesData.map((data: any, index: number) => {
                                return (
                                    <Col key={index} sm={12} md={6} lg={3}>
                                        {(() => {
                                            // check if image data exists coming from CMS
                                            if (data.fieldAdditionalServiceImage !== undefined && data.fieldAdditionalServiceImage !== null) {
                                                return (
                                                    // build image element
                                                    <Media object src={data.fieldAdditionalServiceImage.url} style={additionalServicesImgStyle} alt={data.fieldAdditionalServiceImage.alt} title={data.fieldAdditionalServiceImage.title} width={""} height={""} />
                                                );
                                            }
                                        })()}
                                        <div className={'additionalServicesDescription'} dangerouslySetInnerHTML={{ __html: data.fieldAdditionalServiceCaption }}></div>
                                    </Col>
                                );
                            })
                        }
                    </Row>
                </ContentBody>
            </ContentBlock>
    );
};
